import {
  faFacebook as iconFacebook,
  faInstagram as iconInstagram,
  faThreads as iconThreads,
  faLinkedin as iconLinkedin,
  faXTwitter as iconX,
  faYoutube as iconYoutube,
} from "@fortawesome/free-brands-svg-icons";

/**
 * Event Social Platform Object Definition
 * @typedef {Object} EventSocialPlatformItem
 * @property {string} id - The unique identifier for the social platform
 * @property {string} name - The name of the social platform
 * @property {string} icon - The icon representing the social platform
 * @property {boolean} active - Indicates if the social platform is active
 * @property {Object|null} campaign - The campaign associated with the social platform, if any
 */

/**
 * Create Event Social Platform Item Object
 * @param {Object} params
 * @param {string} params.id - The unique identifier for the social platform
 * @param {string} params.name - The name of the social platform
 * @param {string} params.icon - The icon representing the social platform
 * @param {boolean} [params.active=false] - Indicates if the social platform is active
 * @param {Object|null} [params.campaign=null] - The campaign associated with the social platform, if any
 * @returns {EventSocialPlatformItem} The created Event Social Platform Item Object
 */
export function createEventSocialPlatformItem({
  id,
  name,
  icon,
  active = false,
  campaign = null,
}) {
  return {
    id,
    name,
    icon,
    active,
    campaign,
  };
}

/** Create Event Social Platform List
 * @returns {EventSocialPlatformItem[]} An array of Event Social Platform Item Objects
 */
export function createEventSocialPlatformList() {
  return [
    createEventSocialPlatformItem({
      id: "facebook",
      name: "Facebook",
      icon: iconFacebook,
      active: true,
    }),
    createEventSocialPlatformItem({
      id: "instagram",
      name: "Instagram",
      icon: iconInstagram,
      active: true,
    }),
    createEventSocialPlatformItem({
      id: "threads",
      name: "Threads",
      icon: iconThreads,
      active: false,
    }),
    createEventSocialPlatformItem({
      id: "linkedin",
      name: "LinkedIn",
      icon: iconLinkedin,
      active: false,
    }),
    createEventSocialPlatformItem({
      id: "x",
      name: "X",
      icon: iconX,
      active: true,
    }),
    createEventSocialPlatformItem({
      id: "youtube",
      name: "YouTube",
      icon: iconYoutube,
      active: false,
    }),
  ];
}
